/**
 * EVENTSFLO-FINANCIAL-TAX-RULES-LINE-LEVEL-AUDIT-VIEW-V1
 *
 * Tiny shared help-popover trigger — a small HelpCircle icon that
 * opens a compact Popover with the passed content. Deliberately
 * minimal so it can sit inside dense forms without visual noise.
 */
import { HelpCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { cn } from "../../lib/utils";

export function HelpPopover({
  title,
  children,
  testId = "help-popover",
  className,
  side = "top",
  align = "start",
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className={cn(
            "inline-flex items-center justify-center h-5 w-5 rounded-full",
            "text-muted-foreground hover:text-foreground",
            "hover:bg-muted transition-colors",
            className,
          )}
          aria-label={title || "Help"}
        >
          <HelpCircle className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side={side}
        align={align}
        className="w-80 text-sm"
        data-testid={`${testId}-panel`}
      >
        {title && (
          <div className="font-semibold mb-1">{title}</div>
        )}
        <div className="text-muted-foreground leading-relaxed space-y-1.5">
          {children}
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default HelpPopover;
